

function formatFcCount (count, casus = 'nom') {
  const number = (count || 0).toString();
  const prelastDigit = number.slice(-2, -1);
  const lastDigit = number.slice(-1);

  if (prelastDigit && prelastDigit === '1') return `${number} карточек`;
  if (['1'].includes(lastDigit)) {
    if (casus === 'acc') return `${number} карточку`;
    return `${number} карточка`;
  }
  if (['2', '3', '4'].includes(lastDigit)) return `${number} карточки`;
  return `${number} карточек`;
}

exports.formatFcCount = formatFcCount;
